import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lm-loading-overlay',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (show()) {
    <div class="lm-loading-overlay">
      <div class="lm-loading-content">
        <span class="lm-overlay-spinner"></span>
        @if (message()) {
        <span class="lm-loading-text">{{ message() }}</span>
        }
      </div>
    </div>
    }
  `,
  styles: [`
    .lm-loading-overlay {
      position: absolute;
      inset: 0;
      z-index: 100;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.7);
      border-radius: inherit;
    }

    .lm-loading-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
    }

    .lm-overlay-spinner {
      display: inline-block;
      width: 32px;
      height: 32px;
      border: 3px solid #e2e8f0;
      border-top-color: var(--lm-primary, #1a6fb5);
      border-radius: 50%;
      animation: lm-overlay-spin 0.7s linear infinite;
    }

    .lm-loading-text {
      font-size: 13px;
      font-weight: 500;
      color: var(--lm-muted, #64748b);
    }

    @keyframes lm-overlay-spin {
      to { transform: rotate(360deg); }
    }
  `],
})
export class LmLoadingOverlayComponent {
  show = input(false);
  message = input('');
}
